module.exports = __webpack_public_path__ + "img/icons8-telegram-app.0e55904e.svg";